/* eslint-disable prettier/prettier */
/* eslint-disable */

// Pages
import OmOss from "pages/OmOss"; // Importer hovedkomponenten direkte
import KontaktOss from "pages/Kontakt";
//import Brands from "pages/Brands";
import LeieSide from "pages/Leie";
import HjemSide from "pages/Hjem";

const routes = [
  {
    name: "Hjem",
    route: "/",
    component: <HjemSide />, // Hvis du ønsker en egen komponent for forsiden
  },
  {
    name: "Utleie",
    route: "/utleie",
    component: <LeieSide />, // Hvis du ønsker en egen komponent for forsiden
  },
  {
    name: "Om oss",
    route: "/om-oss",
    component: <OmOss />, // Bruk OmOss direkte her
  },
  {
    name: "Kontakt",
    route: "/kontakt-oss",
    component: <KontaktOss />,
  },
 // Kommentert ut for å bruke senere når innhold kommer - BRANDS
 // {
 // name: "Brands",
 //   route: "/brands",
 //   component: <Brands />,
 // },
];

export default routes;
